"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const babel = require("babel-core");
const stopifyCallCC = require("../stopify/stopifyCallCC");
const babylon = require("babylon");
/**
 * Compiles (i.e., "stopifies") a program. This function should not be used
 * directly by clients of Stopify.
 *
 * @param src the program to Stopify
 * @param opts compiler options
 * @returns the stopified program
 */
function compileFromAst(src, opts) {
    const babelOpts = {
        plugins: [[stopifyCallCC.plugin, opts]],
        babelrc: false,
        ast: false,
        code: true,
        minified: true,
        comments: false,
    };
    const { code } = babel.transformFromAst(src, undefined, babelOpts);
    return code;
}
exports.compileFromAst = compileFromAst;
/**
 * Compiles (i.e., "stopifies") a program. This function should not be used
 * directly by clients of Stopify.
 *
 * @param src the program to Stopify
 * @param opts compiler options
 * @returns the stopified program
 */
function compile(src, opts) {
    return compileFromAst(babylon.parse(src).program, opts);
}
exports.compile = compile;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcGlsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcGlsZXIvY29tcGlsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxvQ0FBb0M7QUFFcEMsMERBQTBEO0FBQzFELG1DQUFtQztBQUVuQzs7Ozs7OztHQU9HO0FBQ0gsU0FBZ0IsY0FBYyxDQUM1QixHQUF3QixFQUN4QixJQUF3QjtJQUV4QixNQUFNLFNBQVMsR0FBRztRQUNoQixPQUFPLEVBQUUsQ0FBQyxDQUFFLGFBQWEsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFFLENBQUM7UUFDekMsT0FBTyxFQUFFLEtBQUs7UUFDZCxHQUFHLEVBQUUsS0FBSztRQUNWLElBQUksRUFBRSxJQUFJO1FBQ1YsUUFBUSxFQUFFLElBQUk7UUFDZCxRQUFRLEVBQUUsS0FBSztLQUNoQixDQUFDO0lBRUYsTUFBTSxFQUFFLElBQUksRUFBRSxHQUFHLEtBQUssQ0FBQyxnQkFBZ0IsQ0FBQyxHQUFHLEVBQUUsU0FBUyxFQUFFLFNBQVMsQ0FBQyxDQUFDO0lBQ25FLE9BQU8sSUFBSyxDQUFDO0FBQ2YsQ0FBQztBQWZELHdDQWVDO0FBR0Q7Ozs7Ozs7R0FPRztBQUNILFNBQWdCLE9BQU8sQ0FBQyxHQUFXLEVBQUUsSUFBd0I7SUFDM0QsT0FBTyxjQUFjLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLENBQUM7QUFDMUQsQ0FBQztBQUZELDBCQUVDIn0=


//////////////////
// WEBPACK FOOTER
// ./dist/src/compiler/compiler.js
// module id = 341
// module chunks = 0